import { useMutation } from '@apollo/client/react'
import React, { FC, useContext } from 'react'
import { Wrapper } from '@src/components/Elements'
import { Form } from '../Form'
import { FormValues } from '../Form/Form'
import { useTranslation } from 'react-i18next'
import { ToastContext, TOAST_TYPES } from '@src/components/Providers'
import { Plot } from '@src/graphql/Plot'

export interface AddProps {
  closeModal: () => void
}

export const Add: FC<AddProps> = ({ closeModal }) => {
  const { t } = useTranslation()
  const { setToast } = useContext(ToastContext)
  const [createPlot, { error }] = useMutation(Plot.createPlot)

  const onSubmit = async (variables: FormValues) => {
    try {
      const { data: data_ } = await createPlot({
        variables,
        refetchQueries: ['plots'],
      })

      if (data_) {
        closeModal()
        setToast({
          type: TOAST_TYPES.SUCCESS,
          message: t('desktop.pages.plots.add.form.success.message'),
          description: t('desktop.pages.plots.add.form.success.description'),
        })
      }
    } catch {
      return false
    }
  }

  return (
    <div>
      <Wrapper>
        <Form onSubmit={onSubmit} error={error} />
      </Wrapper>
    </div>
  )
}
